import type { JSX } from 'react';

/**
 * Figma: Web app → node 4427:58.
 * Step card copy is one paragraph with inline color spans:
 * - title: gray-50 (foreground-primary)
 * - description: gray-500 (foreground-secondary / dark:text-foreground-disabled)
 * - typography: 18px with 24px line-height.
 */
const STEP_COPY_CLASS =
  'text-[1.125rem] leading-[0] tracking-[-0.18px] [word-break:break-word]'; /* ARBITRARY: Figma 4427:58 step copy 18px */

export function HowItWorksStepCopy({
  title,
  description,
}: {
  title: string;
  description: string;
}): JSX.Element {
  const titleWithPeriod = title.endsWith('.') ? title : `${title}.`;

  return (
    <>
      <h3 className="sr-only">{title}</h3>
      <p className={STEP_COPY_CLASS}>
        <span className="leading-[24px] tracking-[-0.16px] font-normal text-foreground-primary">
          {titleWithPeriod}
        </span>{' '}
        <span className="leading-[24px] tracking-[-0.16px] font-normal text-foreground-secondary dark:text-foreground-disabled">
          {description}
        </span>
      </p>
    </>
  );
}
